<template>
  <div class="full-view-header header-steps-wrapper flex flex-align-center flex-justify-center pd-2rem gap-1vw">
    <div class="header-steps-container m-w-100 gap-1vw w-auto bg-white rounded-button shadow-dark flex flex-align-center flex-justify-between p-l-2rem">
      <p class="steps body-base flex flex-align-center flex-justify-center p-r-1rem">
        <span class="p-r-05rem">STEP {{ currentStep }} OF 4:</span>
        <span class="dot">
          <span :class="1 <= currentStep ? 'selected' : ''"></span>
        </span>
        <span class="dot">
          <span :class="2 <= currentStep ? 'selected' : ''"></span>
        </span>
        <span class="dot">
          <span :class="3 <= currentStep ? 'selected' : ''"></span>
        </span>
        <span class="dot">
          <span></span>
        </span>
      </p>
      
      <div class="steps-text body-base flex flex-align-center gap-1vw desktop">
        <p :class="1 == currentStep ? 'selected' : ''">Pick Gifts</p>
        <div class="step-arrow"> > </div>
        <p :class="2 == currentStep ? 'selected' : ''">Select Your Box</p>
        <div class="step-arrow"> > </div>
        <p :class="3 == currentStep ? 'selected' : ''">Write Your Card</p>
        <div class="step-arrow"> > </div>
        <p>Shipping</p>
      </div>
      
      <p class="body-base mobile">{{ stepText }}</p>
      
      <button 
        :disabled="!canNext" 
        @click="$emit('next-step')" 
        class="hb-btn primary slim p-l-unset p-r-unset"
      >
        <span class="p-r-2rem p-l-2rem desktop">Next Step ></span>
        <span class="p-r-1rem p-l-1rem mobile">Next ></span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderSteps',
  
  props: {
    currentStep: {
      type: Number,
      required: true
    },
    canNext: {
      type: Boolean,
      required: true
    }
  },
  
  computed: {
    stepText() {
      const stepMap = {
        1: "Pick Gifts",
        2: "Select Box", 
        3: "Write Card"
      };
      return stepMap[this.currentStep] || "";
    }
  }
}
</script>

<style scoped>
.header-steps-wrapper {
  background-color: #fffdfa;
  border-bottom: 1px solid gray;
}

.steps .dot {
  display: flex;
  align-items: center;
  padding: 0.5%;
  border-radius: 50%;
  margin: 0% 0.5%;
}

.steps .dot span {
  height: 0.6vw;
  width: 0.6vw;
  background-color: black;
  border-radius: 50%;
  display: inline-block;
  opacity: 0.5;
}

.steps .dot span.selected {
  opacity: 1;
}

.steps-text p {
  opacity: 0.3;
}

.steps-text p.selected {
  opacity: 1;
}

@media screen and (max-width: 767px) {
  .header-steps-wrapper {
    padding: 2rem 1rem;
  }
  
  .steps .dot span {
    width: 2vw;
    height: 2vw;
  }
}
</style>
